export default "__VITE_ASSET__BEU1POrL__";